"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAssetKey = void 0;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var ASSET_POLL_TIMEOUT = 5000;
var MAX_RETRIES = 36;

var getAssetKey = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref) {
    var handle, getMetadata, metadata;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            handle = _ref.handle, getMetadata = _ref.getMetadata;
            _context2.next = 3;
            return getMetadata(handle);

          case 3:
            metadata = _context2.sent;

            if (metadata.key) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              var intervalId = null;
              var retry = 0;
              intervalId = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var metadata;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (retry > MAX_RETRIES) {
                          reject();
                        }

                        _context.next = 3;
                        return getMetadata(handle);

                      case 3:
                        metadata = _context.sent;
                        retry += 1;

                        if (metadata.key) {
                          if (intervalId) {
                            clearInterval(intervalId);
                          }

                          resolve(metadata.key);
                        }

                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })), ASSET_POLL_TIMEOUT);
            }));

          case 6:
            return _context2.abrupt("return", metadata.key);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getAssetKey(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getAssetKey = getAssetKey;